import { styled } from '@mui/material';

export const StyledRecordVerify = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 960px;
  min-height: 276px;
  gap: 24px;
  border-radius: 16px;
  padding: 24px 40px 24px 40px;
  background-color: #f4f5f7a3;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  max-height: max-content;
`;

export const StyledRecord = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ showStartButton }) => (showStartButton ? '60px' : '24px')};
  height: 100%;
`;

export const StyledSentences = styled('div')`
  padding: 0px 160px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

export const StyledRecordTime = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  gap: 2px;
  height: 32px;
  gap: 8px;
  opacity: 1;
  border-radius: 480px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  box-sizing: border-box;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const StyledRecordAgain = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const StyledCountTime = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const StyledRecordingTime = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const StyledProcessingAudio = styled('div')`
  width: 600px;
  max-width: 100%;
  margin: auto;
  gap: 16px;
  .processing-audio-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
